import { useEffect, useState } from 'react';
import { ScheduleTreatment } from '../../../entities/ScheduleTreatment';
import ScheduleTreatmentModel from './model';

type ScheduleTreatmentViewModel = {
  scheduleTreatments: ScheduleTreatment[];
};

export default function ScheduleTreatmentViewModel({ scheduleTreatments }: ScheduleTreatmentViewModel) {
  const model = ScheduleTreatmentModel;
  const [scheduleTreatment, setScheduleTreatment] = useState<ScheduleTreatment | null>(null);
  const [days, setDays] = useState<Date[]>([]);
  const [selectedDay, setSelectedDay] = useState<Date | null | undefined>(null);

  useEffect(() => {
    if (scheduleTreatments && scheduleTreatments.length > 0) {
      setDays(model.listOfDays(scheduleTreatments));
    }
  }, [scheduleTreatments]);

  useEffect(() => {
    if (selectedDay && scheduleTreatments) {
      const filteredTreatments = model.filterTreatmentsByDate(scheduleTreatments, selectedDay);
      const orderedTreatment = model.orderByTratmentByDate(filteredTreatments);
      setScheduleTreatment(orderedTreatment || null);
    } else {
      setScheduleTreatment(null);
    }
  }, [selectedDay, scheduleTreatments]);

  return {
    days,
    scheduleTreatment,
    selectedDay,
    setSelectedDay
  };
}
